import React, { useEffect, useRef } from 'react';
import { StyledHeroParallax } from './StyledHeroParallax';
import parallax1 from '../../assets/parallax-1.jpg';
import parallax2 from '../../assets/parallax-2.jpg';
import parallax3 from '../../assets/CPG_super_618x414.png';
import parallax4 from '../../assets/parallax-4.jpg';
import gsap from 'gsap';
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const lerp = (a, b, n) => (1 - n) * a + n * b;
const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;
const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
const getMousePos = (e) => {
  let posx = 0;
  let posy = 0;
  if (!e) e = window.event;
  if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
  }
  else if (e.clientX || e.clientY)    {
      posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }
  
  return { x : posx, y : posy }
};

const calcWinsize = () => {
  return {width: window.innerWidth, height: window.innerHeight};
};
let winsize = calcWinsize();
let mousepos = {x: winsize.width/2, y: winsize.height/2};

const HeroParallax = ({ }) => {
  const animationFrame = useRef([]);
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  function move(el, index) {
    // amounts to move in each axis
    let translationVals = {tx: 0, ty: 0};
    // get random start and end movement boundaries
    const xstart = getRandomNumber(15,60);
    const ystart = getRandomNumber(15,60);
    
    // infinite loop
    const render = () => {
      
        // Calculate the amount to move.
        // Using linear interpolation to smooth things out. 
        // Translation values will be in the range of [-start, start] for a cursor movement from 0 to the window's width/height
        translationVals.tx = lerp(translationVals.tx, map(mousepos.x, 0, winsize.width, -xstart, xstart), 0.07);
        translationVals.ty = lerp(translationVals.ty, map(mousepos.y, 0, winsize.height, -ystart, ystart), 0.07);
        
        gsap.set(el, {x: translationVals.tx, y: translationVals.ty});  
        animationFrame.current.push(requestAnimationFrame(render))
    }
    render()

  }
  useEffect(() =>{
    const items = document.querySelectorAll('.parallax--item');
    items.forEach((item, index) => {
      move(item, index)
    })
    const isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

    if(!isTouch){
      window.addEventListener('mousemove', ev => mousepos = getMousePos(ev) )
       window.addEventListener('resize', () => winsize = calcWinsize());
    } 
    

    return () => {
      if(!isTouch){
        window.removeEventListener('mousemove', ev => mousepos = null )
        window.removeEventListener('resize', () => winsize = null);
        for(var i = 0; i < animationFrame.current.length; i++){
          cancelAnimationFrame(animationFrame.current[i])
        }
      }
    }
  }, [])
    
  

  return (
    <React.Fragment>
      {
       
        <StyledHeroParallax>
          <div className="parallax--wrap">
            <div className="parallax--item pos-1">
              <div className="parallax--item-img" style={{backgroundImage: `url(${parallax1})`}}></div>
            </div>
            <div className="parallax--item pos-2">
              <div className="parallax--item-img" style={{backgroundImage: `url(${parallax2})`}}></div>
            </div>
            <div className="parallax--item pos-3">
              <div className="parallax--item-img" style={{backgroundImage: `url(${parallax3})`}}></div>
            </div>
            <div className="parallax--item pos-4">
              <div className="parallax--item-img" style={{backgroundImage: `url(${parallax4})`}}></div>
            </div>
            
          </div>
          <div className="text--wrap">
            <h5 className="big--title">What is Full Reality?</h5>
            <div className="cta--primary cursor-cta" onClick={() => handleCLick('/full-reality')}>
              <p className="preset-10 cursor-cta">Read the Manifesto</p>
              <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
                <path className="cursor-cta" d="M13 6H1" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
            </div>
          </div>
        </StyledHeroParallax>
          
      }
    </React.Fragment>
  );
};

export default HeroParallax;
